import React from "react";
import { useNavigate } from "react-router-dom";
import { ResetSuccessPage, CustomBrandLogo } from "@ippon/shared-auth";
import {
  resolveOriginLoginUrl,
  clearOriginServiceId,
} from "@/utils/originService";

const ResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  // 遷移前の service_id を見て、元アプリ(物件管理等)のログインへ戻す。
  // 委譲元が無ければ設定画面自身の /login へフォールバック。
  const handleLogin = () => {
    const originLoginUrl = resolveOriginLoginUrl();
    clearOriginServiceId();
    if (originLoginUrl) {
      window.location.href = originLoginUrl;
    } else {
      navigate("/login", { replace: true });
    }
  };

  return (
    <ResetSuccessPage renderLogo={<CustomBrandLogo />} onLogin={handleLogin} />
  );
};

export default ResetSuccess;
